import { useEffect, useState } from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import { ItemValidationRule } from '../../../model/ItemModel';

export function UseStatus(
  isReleaseConst: boolean, 
  validationRuleConst: ItemValidationRule | undefined, 
  itemType: string, 
  batchWaiter: boolean | undefined, 
  archiving: boolean | undefined, 
  expired: boolean | undefined,
  d4signed: boolean | undefined,
  t: TFunction<"translation", undefined>
) {
  if(expired == true)
  {
    return(t("Temporality.Expired"));
  }
  else if(archiving == true){
    return(t("Temporality.Filed"));
  }
  else{
    if (d4signed) {
      if (itemType === "folder") {
        return (t("Item.folder"));
      }
      else {
        return (t("Temporality.Signed"));
      }
    }
    if (isReleaseConst) {
      if (itemType === "folder") {
        return(t("Item.folder"));
      }
      else {
        return("Release");
      }
    }
    else if(validationRuleConst !== undefined) {
      if(validationRuleConst.validationRuleDeleted === false) {
        if(itemType == "folder") {
          return(t("Item.folder"));
        } 
        else {
          if(validationRuleConst?.currentOperation){
            return("Flow");
          }
        }
      }
      else{
        return(t("Temporality.Removed"));
      }
    }
    else{
      if(itemType == "folder"){
        return(t("Item.folder"));
      }
      else{
        return("Draft");
      }
    } 

    return "";
  }
}

export function UseStatusWithCurrentOperation(
  isReleaseConst: boolean, 
  validationRuleConst: ItemValidationRule | undefined, 
  itemType: string, 
  batchWaiter: boolean | undefined, 
  archiving: boolean | undefined, 
  expired: boolean | undefined,
  d4Signed: boolean | undefined
) {

    const [status, setStatus] = useState<string>("");
    const { t } = useTranslation();

    function validationRuleValidation() {
      setStatus(UseStatus(isReleaseConst, validationRuleConst, itemType, batchWaiter, archiving, expired, d4Signed, t));
    }

    function getCurrentOperation(): string | undefined {
      return validationRuleConst?.currentOperation;
    }

    useEffect(() => {
        validationRuleValidation();
    }, [isReleaseConst, validationRuleConst, batchWaiter])

    return {
        currentStatus: status,
        currentOperation: getCurrentOperation()
    }
}